<template>
  <a
    class="oss-media-link"
    href="#"
    v-bind="forwardedAttrs"
    @click="handleClick"
  >
    <slot />
  </a>
</template>

<script>
import { resolveDisplayMediaUrl } from '../utils/mediaUrl'
import { getUploadSchoolId } from '../utils/ossMediaUpload'

/**
 * 点击打开/下载媒体：自动解析 OSS 预签名，适用于详情附件下载链接。
 * 最后更新：2026-07-01
 */
export default {
  name: 'OssMediaLink',
  inheritAttrs: false,
  props: {
    path: { type: String, default: '' },
    schoolId: { type: [String, Number], default: '' },
    inline: { type: Boolean, default: true },
    download: { type: Boolean, default: false },
  },
  computed: {
    forwardedAttrs() {
      const attrs = { ...this.$attrs }
      delete attrs.href
      return attrs
    },
  },
  methods: {
    async handleClick(e) {
      e.preventDefault()
      const p = String(this.path || '').trim()
      if (!p) return
      const schoolId = this.schoolId || getUploadSchoolId(this)
      try {
        const url = await resolveDisplayMediaUrl(p, schoolId, { inline: this.inline })
        if (this.download) {
          const a = document.createElement('a')
          a.href = url
          a.target = '_blank'
          a.rel = 'noopener'
          a.download = ''
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        } else {
          window.open(url, '_blank', 'noopener')
        }
      } catch (err) {
        console.warn('[OssMediaLink]', err)
        this.$message && this.$message.error('获取文件地址失败')
      }
    },
  },
}
</script>
